import { render } from "./TabelaComissao.vue?vue&type=template&id=1523ff1e"
import script from "./TabelaComissao.vue?vue&type=script&lang=js"
export * from "./TabelaComissao.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__